import {
    MENUANDPAGES_LOADING,
    GET_MENUANDPAGES_DATA_SUCCESS,
    GET_MENUANDPAGES_DATA_ERROR, RESET_MENUANDPAGES
} from "../actions/actionMenuAndPages";

const initialState = {
    menuAndPages: [],
    loading: false,
    menuAndPagesError: '',
};

function reducerMenuAndPages(state = initialState, action) {
    switch (action.type) {

        case MENUANDPAGES_LOADING: {
            return {
                ...state,
                loading: true,
                menuAndPages: [],
                menuAndPagesError: ''
            };
        }

        case GET_MENUANDPAGES_DATA_SUCCESS: {

            let mp = [
                ...action.payload
            ]

            return {
                ...state,
                loading: false,
                menuAndPages: mp,
                menuAndPagesError: ''
            };
        }

        case GET_MENUANDPAGES_DATA_ERROR: {
            return {
                ...state,
                loading: false,
                menuAndPages: [],
                menuAndPagesError: action.error
            }
        }
        case RESET_MENUANDPAGES: {

            return {
                ...state,
                loading: false,
                menuAndPages: [],
                menuAndPagesError: ''
            }
        }
        default: {
            return state;
        }
    }
}

export default reducerMenuAndPages;